import '../polyfill'
import Vue from 'vue'
import Element from 'element-ui'
import VueRouter from 'vue-router'
import './normalize.styl'
import './app.styl'
import './help.styl'
import './element-ui-fix.styl' // 自定义element-ui 全局样式
import './adapter.styl'
import VueImg from 'v-img'
// import moment from 'moment'
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
// import 'moment/locale/zh-cn'
import VueEleForm from '@meta-vue/vue-ele-form'
import FormExtend, {
  CrmImageUploader,
  IframeWrapForm,
  CxUpload,
  SopInput,
  ServiceStandard
} from '@meta-vue/ele-form-crm-extends'
import NumberInput from '@meta-vue/number-input'
import SummaryComplaints from '@/components/summary-complaints'

import CrmLocation from '@crm-mb-ui/geo-location'
// import ConvertMaskToggle from '@/components/ConvertMaskToggleBtn'
import FormCustom from '@meta-vue/ele-form-custom'
import '@/components/biz-search-input/index.js'
import vueDraggable from 'vuedraggable'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import FileImageUpload from '@/components/file-image-upload/index.vue'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import InfiniteList from '@meta-vue/infinite-list'
import crmIconfont from '@meta-vue/crm-iconfont'
import { directives } from '@meta-vue/cx-directive'
import Descriptions from '@/components/descriptions'
import DescriptionsItems from '@/components/descriptions-item'
import elcImage from '@meta-vue/cx-image'
import SearchTable from '@meta-vue/search-table'
import TableRender from '@meta-vue/table-render'
import vueLazyload from 'vue-lazyload'
import CopyField from '@meta-vue/copy-plain-masker-field'
import horizontalScroll from '@/extend/directive/el-table-horizontal-scroll.js'

import { WbLabels, WbTable, WbSearchTable, registerConfig } from '@meta-vue/cx-workbench-descriptions'
import CxCopyValue from '@meta-vue/cx-copy-value' // 临时补偿@meta-vue/element-ui样式
import EnhancementCxUpload from '@/components/enhancement/cxupload.vue' // 增强cxUpload
import EnhancementyUpload from '@/components/enhancement/yupload.vue' // 增强yUpload
require('@/extend/directive/index')
import { i18n } from '@/i18n/index.js'

Vue.use(directives)
window.Vue = Vue
window.VueRouter = VueRouter
window.ELEMENT = Element

Vue.use(PerfectScrollbar)
Vue.use(contentmenu)
Vue.use(Element)
Vue.use(VueImg)
Vue.use(VueEleForm)
Vue.use(CrmImageUploader)
Vue.use(InfiniteList)
Vue.use(FormExtend)
Vue.use(Descriptions)
Vue.use(DescriptionsItems)
Vue.use(vueLazyload, {
  lazyComponent: true
})
Vue.use(horizontalScroll)

// // 注册 image-uploader 组件
Vue.component('image-uploader', CrmImageUploader)
Vue.component('crm-location', CrmLocation)
Vue.component('cx-copy-value', CxCopyValue)
Vue.component('iframe-wrap-form', IframeWrapForm)
//Vue.component('video-uploader', VideoUploader)
Vue.component('video-uploader', CrmImageUploader)

Vue.component('crm-position-picker', CrmLocation)

// Vue.component('ConvertMaskToggle', ConvertMaskToggle)
Vue.component('vue-draggable', vueDraggable)
Vue.component('FormCustom', FormCustom)
Vue.component('FileImageUpload', FileImageUpload)
Vue.component('CxNumberInput', NumberInput)
// Vue.component('number-input', NumberInput)

Vue.component('wb-labels', WbLabels)
Vue.component('wb-table-render', WbTable)
Vue.component('wb-search-table', WbSearchTable)
Vue.component('search-table', SearchTable)
Vue.component('table-render', TableRender)
Vue.component('SopInput', SopInput)
Vue.component('ServiceStandard', ServiceStandard)
Vue.component('SummaryComplaints', SummaryComplaints)
Vue.component('el-image', elcImage)
Vue.component('CopyField', CopyField)
Vue.component('CxUpload', EnhancementCxUpload)
// Vue.component('crm-image-uploader', EnhancementyUpload)

Vue.config.productionTip = false
// moment.locale('zh-cn')

const [routerPush, routerReplace] = [VueRouter.prototype.push, VueRouter.prototype.replace]
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}

Vue.use(crmIconfont, {
  src: [
    './iconfont/resource/d8124410-7e65-4cec-9e4e-e360c2515557.js',
    './iconfont/resource/f5441060-acc8-417c-8546-56a2512ed09f.css'
  ]
})

export function beforeAppCreate(initOptions) {
  initOptions.i18n = i18n
  const PubSiderBar = window['crm-pubsidebar']
  if (PubSiderBar) {
    Vue.use(PubSiderBar.default)
  } else {
    window.Vue = Vue
  }
}
